<template>
    <v-row justify="center" class="absolute" >
        <v-dialog v-model="dialog" persistent max-width="600" @click:outside="$store.dispatch('changePom', false)" >

            <v-card dark shaped :class="`${routeLink}_color`" class="!flex flex-col justify-center items-center p-5">
                <v-card-title class="!text-2xl !font-Handel text-black !pt-2 capitalize !items-center">
                    Profile of the Month
                </v-card-title>
                <v-card-text class="capitalize font-Handel">
                    <span class=" !text-black">
                        "if you think you are sexy then show it",
                    </span> Participate Now in sexiest profile of the month.
                </v-card-text>
                <div class="w-full relative  font-Handel text-2xl" v-if="contestWinner.name">
                    <v-img :src="contestWinner.name" :lazy-src="contestWinner.name"
                        gradient="to bottom , transparent , black" height="500" position="top center"></v-img>
                    <div class="absolute bottom-7  flex justify-between w-full px-4 items-center">
                        <div class="flex">
                            <v-icon class="" :color="colorAsRoute" left x-large>mdi-trophy-award</v-icon>
                            <div>
                                <h2 :class="`${routeLink}_fortext`" class="capitalize">{{ contestWinner.user.name }}
                                </h2>
                                <div class="text-sm">{{ contestWinner.user.age }}Y, {{ contestWinner.user.location }}</div>
                            </div>
                        </div>
                        <v-btn icon @click="liked = !liked" :color="colorAsRoute">
                            <v-icon :color="colorAsRoute" class="cursor-pointer">{{ liked ? 'mdi-heart' :
                                'mdi-heart-outline'
                            }}</v-icon>
                        </v-btn>
                    </div>

                </div>
                <div v-else class="w-full h-64 bg-black flex items-center justify-center rounded-xl text-xl capitalize text-gray-300 p-3 text-center font-Nunito">
                    <div>please note that <strong>no winner has been announced yet</strong>. Please checking back for updates!</div>
                </div>

                <v-card-actions class="align-self-end !pr-0">
                    <v-spacer></v-spacer>
                    <v-btn color="black" class="font-Handel" text @click="$store.dispatch('changePom', false)">
                        Cancel
                    </v-btn>
                    <v-btn :color="colorAsRoute" outlined class="font-Handel black" text @click="participate()">
                        Participate Now
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            // dialog: false,
            liked: false,
            contestWinner: {}
        }
    },
    computed: {
        dialog() {
            return this.$store.getters.PlayerOfMonth
        },
        colorAsRoute() {
            if (this.routeLink == 'straight') {
                return '#a07a1d'
            }
            else if (this.routeLink == 'gay') {
                return '#88c3fa'
            }
            else if (this.routeLink == 'lesbian') {
                return '#9e2eec'
            }
        },
    },
    methods: {
        participate() {
            this.$store.dispatch('changePom', false)
            this.$store.dispatch('changeParticipantPom', true)
        },
        async playerOfMonth() {
            
                const { data } = await axios.get('users/contest/winner')
                // console.log(data.data);
                this.contestWinner = data.data
            
        }
    },
    created() {
        this.playerOfMonth()
    },
}
</script>
<style scoped>
.straight_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(335deg,
            rgb(136 97 0) 0%,
            rgb(255 223 153) 53%,
            rgb(130 93 0 / 97%) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.gay_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(185deg,
            rgba(0, 240, 255, 1) 55%,
            rgba(0, 156, 255, 1) 75%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.lesbian_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(208deg,
            rgba(126, 0, 157, 0.9416141456582633) 2%,
            rgba(161, 51, 246, 1) 45%,
            rgba(157, 0, 176, 0.9668242296918768) 96%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
</style>